<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '90vw', height: '90vh'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
  [closable]="false"
  [closeOnEscape]="true"
  styleClass="p-dialog-scheda-nuova"
>
  <ng-template pTemplate="header">
    <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
      <span class="material-icons header-icon">map</span>
      <h2>Aggiorna la geometria della scheda</h2>
      <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
        <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ scheda?.codice }}</span>
      </div>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-danger close-button"
        (click)="onHide()"
        [disabled]="submitting"
        pTooltip="Chiudi"
        tooltipPosition="left">
      </button>
    </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="upload-container" *ngIf="!uploadedGeoJSON">
      <div class="card-pdf-upload" style="width: 100%;">
        <p-fileUpload
          mode="basic"
          chooseLabel="Seleziona il file contenente la geometria"
          accept=".geojson,.json"
          [maxFileSize]="10000000"
          [auto]="false"
          [disabled]="submitting"
          [style]="{'width':'100%'}"
          styleClass="p-button-outlined p-button-primary upload-button"
          (onSelect)="onGeoJSONSelect($event)"
        >
        </p-fileUpload>
      </div>
    </div>

    <div *ngIf="uploadedGeoJSON" class="file-info mt-3">
      <i class="pi pi-map" style="font-size: 1.5rem; color: #2196F3;"></i>
      <div class="file-details">
        <span class="file-name">{{ uploadedGeoJSON.name }}</span>
        <span class="file-size">{{ (uploadedGeoJSON.size / 1024 / 1024).toFixed(2) }} MB</span>
      </div>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-danger ml-auto"
        (click)="onGeoJSONClear()"
        pTooltip="Rimuovi file">
      </button>
    </div>

    <div class="map-container" #map></div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <button
        pButton
        type="button"
        label="Annulla"
        class="p-button-outlined p-button-secondary"
        (click)="onHide()"
        [disabled]="submitting">
      </button>
      <button
        pButton
        type="button"
        label="Salva"
        class="p-button-success"
        (click)="salvaGeoJSON()"
        [disabled]="!uploadedGeoJSON || submitting">
      </button>
    </div>
  </ng-template>
</p-dialog>
